export default {"src":"/_next/static/media/pestsSide.2eca1fd9.svg","height":22,"width":26,"blurWidth":0,"blurHeight":0};